module.exports = __webpack_public_path__ + "static/media/empty-search.bccbdf70.png";